<div style="width: 100%" [nbSpinner]="this.isLoading">
  <mat-form-field style="width: 100%">
    <mat-label>{{"Warehouse" | tenantWords}}</mat-label>
    <mat-select (selectionChange)="this.onSelectChange()" id="select" [required]="this.isRequired" [(ngModel)]="warehouse" name="select" #select="ngModel"
      (ngModelChange)="onSelectChange()">
      <mat-option>
        <ngx-mat-select-search [(ngModel)]="this.searchValue" (ngModelChange)="filter()" placeholderLabel="Find..."
          noEntriesFoundLabel="None found" name="search" #search="ngModel">
        </ngx-mat-select-search>
      </mat-option>
      <mat-option *ngIf="this.objList.length === 0">
        Please search for a {{"warehouse" | tenantWords}}.
      </mat-option>
      <mat-option *ngFor="let x of this.objList" [value]="x">
        {{x.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div [hidden]="select.valid || select.pristine" class="alert alert-danger">
    Warehouse is required
  </div>
</div>